function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

import { useEffect } from 'react';

function createSVG() {
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.id = 'slIconsSvg';
  svg.style.position = 'absolute';
  svg.style.visibility = 'hidden';
  svg.style.width = '0px';
  svg.style.height = '0px';
  return svg;
}
function getSVG() {
  return document.getElementById('slIconsSvg') || null;
}
function appendSVG(svg) {
  document.body.appendChild(svg);
}
function getSymbol(svg, iconId) {
  return svg.getElementById(iconId);
}
function appendSymbol(svg, symbol) {
  svg.innerHTML = symbol.symbol + svg.innerHTML;
}
function useIcons(icons) {
  useEffect(function () {
    var svg = getSVG() || createSVG();
    if (!getSVG()) {
      appendSVG(svg);
    }
    icons.forEach(function (icon) {
      import("./iconsList/".concat(icon)).then(function (data) {
        if (!getSymbol(svg, data[icon].id)) {
          appendSymbol(svg, data[icon]);
        }
      });
    });
  }, []);
  return icons;
}

export { useIcons };
